/*
 * Action-type constants for /event-types CRUD + list
 * (matches the structure used by invoice-rows.js)
 */

export const ACTIONS = {
  /* ---------- LIST ---------- */
  EVENT_TYPES_FETCH_START: 'EVENT_TYPES_FETCH_START',
  EVENT_TYPES_FETCH_SUCCESS: 'EVENT_TYPES_FETCH_SUCCESS',
  EVENT_TYPES_FETCH_FAILURE: 'EVENT_TYPES_FETCH_FAILURE',
  EVENT_TYPES_FETCH_RESET: 'EVENT_TYPES_FETCH_RESET',

  /* ---------- SINGLE FETCH ---------- */
  EVENT_TYPE_FETCH_START: 'EVENT_TYPE_FETCH_START',
  EVENT_TYPE_FETCH_SUCCESS: 'EVENT_TYPE_FETCH_SUCCESS',
  EVENT_TYPE_FETCH_FAILURE: 'EVENT_TYPE_FETCH_FAILURE',

  /* ---------- CREATE ---------- */
  EVENT_TYPE_CREATE_START: 'EVENT_TYPE_CREATE_START',
  EVENT_TYPE_CREATE_SUCCESS: 'EVENT_TYPE_CREATE_SUCCESS',
  EVENT_TYPE_CREATE_FAILURE: 'EVENT_TYPE_CREATE_FAILURE',

  /* ---------- UPDATE ---------- */
  EVENT_TYPE_UPDATE_START: 'EVENT_TYPE_UPDATE_START',
  EVENT_TYPE_UPDATE_SUCCESS: 'EVENT_TYPE_UPDATE_SUCCESS',
  EVENT_TYPE_UPDATE_FAILURE: 'EVENT_TYPE_UPDATE_FAILURE',

  /* ---------- DELETE ---------- */
  EVENT_TYPE_DELETE_START: 'EVENT_TYPE_DELETE_START',
  EVENT_TYPE_DELETE_SUCCESS: 'EVENT_TYPE_DELETE_SUCCESS',
  EVENT_TYPE_DELETE_FAILURE: 'EVENT_TYPE_DELETE_FAILURE',

  /* ---------- MISC ---------- */
  EVENT_TYPE_RESET: 'EVENT_TYPE_RESET',
};
